/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { EnrollmentAction, STORE_ENROLLMENTS, AddEnrollmentAction, ADD_ENROLLMENT } from "../actions/actions";
import { Enrollment } from "../../models/model";

export function enrollments(state: Enrollment[] = [], action: EnrollmentAction & AddEnrollmentAction): Enrollment[] {
    switch (action.type) {
        case STORE_ENROLLMENTS: {
            return action.payload as Enrollment[];
        }
        case ADD_ENROLLMENT: {
            return [
                ...state.filter(
                    e =>
                        e.offeringId != action.payload.offeringId ||
                        e.partnerId.type != action.payload.partnerId.type ||
                        e.partnerId.value != action.payload.partnerId.value
                ),
                action.payload
            ];
        }
        default:
            return state;
    }
}
